import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import moment from "moment";

export default function Statements() {

    const { currentUser } = useSelector((state) => state.auth);
    const [statements, setStatements] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSizeValue, setPageSizeValue] = useState(10);
    const [recordCount, setRecordCount] = useState(0);
    const [sortDirection, setSortDirection] = useState("desc"); // Default sorting direction
    const [sortBy, setSortBy] = useState("EntrySystemDate"); // Default sorting
    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {
        getStatements();
    }, [sortBy, sortDirection, filterValue, pageNumber, pageSizeValue]);

    async function getStatements() {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}statements`,
                {
                    userId: currentUser.id,
                    customer_code:
                        currentUser.isCustomer === 1 &&
                            currentUser.customer_code !== null
                            ? currentUser.customer_code
                            : currentUser.customer_code === null ||
                                currentUser.customer_code.split(",").length > 1
                                ? "None"
                                : currentUser.customer_code,
                    pageNumber: pageNumber,
                    pageSizeValue: pageSizeValue,
                    sortBy: sortBy,
                    sortDirection: sortDirection,
                    filterItem: filterValue,
                },
                { headers: { Authorization: `Bearer ${currentUser.token}` } }
            );

            setStatements(response.data.data);
            setRecordCount(response.data.total);
        } catch (error) {
            console.error("Error fetching statements:", error);
        }
    }

    const handleDownload = async (id) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}statements/download/${id}`,
                {
                    headers: { Authorization: `Bearer ${currentUser.token}` },
                    responseType: "blob",
                }
            );
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "statement.pdf");
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error("Error downloading statement:", error);
        }
    };
    const months = [
        { name: 'Jan', value: '01' },
        { name: 'Feb', value: '02' },
        { name: 'Mar', value: '03' },
        { name: 'Apr', value: '04' },
        { name: 'May', value: '05' },
        { name: 'Jun', value: '06' },
        { name: 'Jul', value: '07' },
        { name: 'Aug', value: '08' },
        { name: 'Sep', value: '09' },
        { name: 'Oct', value: '10' },
        { name: 'Nov', value: '11' },
        { name: 'Dec', value: '12' }
    ];


    return (
        <div className="container mx-auto pt-10">
            <h2 className="text-2xl font-semibold mb-4">Monthly Statements</h2>
            <table className="w-full text-left">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="px-4 py-2">Year</th>
                        <th className="px-4 py-2">Month</th>
                        <th className="px-4 py-2">Filename</th>
                        {/* <th className="px-4 py-2">Sequence</th> */}
                        <th className="px-4 py-2">Download</th>
                    </tr>
                </thead>
                <tbody>
                    {statements.map((s) => {
                        const rawMonth = s.month.toString();
                        const paddedMonth = rawMonth.padStart(2, "0");
                        const monthName = months.find(m => m.value === paddedMonth)?.name;

                        return (
                            <tr key={s.id} className="border-b">
                                <td className="px-4 py-2">{s.year}</td>
                                <td className="px-4 py-2">{monthName}</td>
                                <td className="px-4 py-2">{s.filename}</td>
                                {/* <td className="px-4 py-2">{s.sequence}</td> */}
                                <td className="px-4 py-2">
                                    <button
                                        className="text-blue-600 underline"
                                        onClick={() => handleDownload(s.id)}
                                    >
                                        Download
                                    </button>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            <div className="flex justify-between mt-4">
                <button
                    onClick={() => setPageNumber((prev) => Math.max(prev - 1, 0))}
                    disabled={pageNumber === 0}
                >
                    Previous
                </button>
                <span>
                    Page {pageNumber + 1} of {Math.ceil(recordCount / pageSizeValue)}
                </span>
                <button
                    onClick={() => setPageNumber((prev) => prev + 1)}
                    disabled={(pageNumber + 1) * pageSizeValue >= recordCount}
                >
                    Next
                </button>
            </div>
        </div>
    );
}
